import apiClient from './apiClient';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  name: string;
  role: 'MDA' | 'ABM_OPS' | 'ABM_MANAGER' | 'SALES' | 'ADMIN';
  team?: string;
}

export interface UserCustomPermission {
  module: string;
  permissions: string[];
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
    customPermissions?: UserCustomPermission[] | null;
  };
}

export interface User {
  id: string;
  email: string;
  name: string;
  role: string;
  customPermissions?: UserCustomPermission[] | null;
}

/**
 * Login user
 */
export const login = async (credentials: LoginCredentials): Promise<AuthResponse> => {
  const response = await apiClient.post<AuthResponse>(
    '/api/auth/login',
    credentials
  );
  return response.data;
};

/**
 * Register new user
 */
export const register = async (data: RegisterData): Promise<AuthResponse> => {
  const response = await apiClient.post<AuthResponse>(
    '/api/auth/register',
    data
  );
  return response.data;
};

/**
 * Get current user info
 */
export const getCurrentUser = async (): Promise<User> => {
  const response = await apiClient.get<User>(
    '/api/auth/me'
  );
  return response.data;
};

/**
 * Logout user
 */
export const logout = async (): Promise<void> => {
  await apiClient.post('/api/auth/logout');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};

/**
 * Refresh access token
 */
export const refreshToken = async (refreshToken: string): Promise<string> => {
  const response = await apiClient.post<{ accessToken: string }>(
    '/api/auth/refresh',
    { refreshToken }
  );
  return response.data.accessToken;
};
